import React from 'react';
import { useT } from '../../i18n/useT';
import './TrustBar.css';

const ICONS = [
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2L3 5v5c0 4 3 7 7 8 4-1 7-4 7-8V5L10 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/><path d="M7 10l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><rect x="3" y="3" width="14" height="14" rx="3" stroke="currentColor" strokeWidth="1.5"/><path d="M7 10l2 2 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="10" cy="10" r="7" stroke="currentColor" strokeWidth="1.5"/><path d="M6 10l3 3 5-5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></svg>,
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><rect x="3" y="6" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.5"/><path d="M7 6V5a3 3 0 016 0v1" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/><circle cx="10" cy="11" r="1.5" fill="currentColor"/></svg>,
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 4h5v5H4zM11 4h5v5h-5zM4 11h5v5H4zM11 11h5v5h-5z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>,
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M10 2l2.4 4.9L18 7.6l-3.6 3.5.85 4.95L10 13.4l-5.25 2.65L5.6 11.1 2 7.6l5.6-.7L10 2z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round"/></svg>,
];

export default function TrustBar() {
  const t = useT();
  const tr = t.trust;
  const items = [tr.encryption, tr.gdpr, tr.uptime, tr.zeroKnowledge, tr.sync, tr.rating];

  return (
    <section className="trust-bar" aria-label="Trust indicators">
      <div className="container-wide">
        <div className="trust-bar__inner">
          {items.map((text, i) => (
            <div key={i} className="trust-bar__item">
              <span className="trust-bar__icon">{ICONS[i]}</span>
              <span className="trust-bar__text">{text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
